<template>
<div class="comm" id="comm_group">
    <div v-for="(items, index) in groupInfo.fieldGroupRelevanceList" style="margin-bottom: 22px" :key="index">
        <el-form-item :class="{'validate-form': items.validate}" v-if="!items.hide && items.fieIdType != 13"
            :rules="[{ required: items.isRequired == 1 ? true : false, trigger: 'blur', message: '请输入' },]">
            <template slot="label">
                <span style="font-weight: 700;color: #333333;" >{{items.fieIdName}}</span>
                <!-- 这里可以放入任何自定义 HTML 或 Vue 组件 -->
            </template>
            <!-- 单选 -->
            <orderRadio @changebox="updateChangeValue" :index="index" :info="items" v-if="items.fieIdType == 1"></orderRadio>
            <!-- 多选 -->
            <!-- <orderCheckbox @changebox="changebox" :index="index" :info="items" v-if="items.fieIdType == 2"></orderCheckbox> -->
            <!-- 单行文本 -->
            <singleText @updateValue="updateLineValue" :index="index" :info="items" v-if="items.fieIdType == 3"></singleText>
            <!-- 多行文本 -->
            <multilineText @updateValue="updateLineValue" :index="index" :info="items" v-if="items.fieIdType == 4"></multilineText>
            <!-- 富文本 -->
            <editor v-if="items.fieIdType == 5" @updateEditor="updateEditor" v-model="items.fieIdValue" :min-height="192" />
            <!-- 整数 -->
            <order-number v-if="items.fieIdType == 6" @updateValue="updateValue" :index="index" :info="items"></order-number>
            <!-- 浮点数 -->
            <order-digit v-if="items.fieIdType == 7" @updateValue="updateValue" :index="index" :info="items"></order-digit>
            <!-- 上传附件 -->
            <uploadText v-if="items.fieIdType == 8" :fileList="items.fileList" :ref="'orderfile' + index + indexs"
                @getFile="getFile1"></uploadText>
            <!-- 数字范围 -->
            <order-range v-if="items.fieIdType == 9" @updateRange="updateRangeValue" :index="index" :info="items"></order-range>
			<group-order-duration v-if="items.fieIdType == 14" @updateRange="updateTimeValue" :index="index" :info="items"></group-order-duration>
			<!-- <div class="tipsWord" v-if="!items.fieldGroupId">{{ items.fieIdRemark }}</div> -->
			<div class="tipsWord" style="margin-left: 100px" v-html="items.fieIdRemark"></div>
        </el-form-item>
    </div>
</div>
</template>

<script>
import multilineText from "./multilineText";
import singleText from "./singleText";
import orderRadio from "./orderRadio";
import orderCheckbox from "./orderCheckbox";
import editor from "./editor";
import orderRange from "./orderRange.vue"
import orderNumber from "./orderNumber.vue"
import orderDigit from "./orderDigit.vue"
import groupOrderDuration from "./groupOrderDuration.vue"
import { getEquipmentFieldGroupList } from "@/api/request";
import mittBus from "@/utils/mittBus";

export default {
name: "",
props:{
    info: {
        type: Object,
        default: () => {
            return {}
        }
    },
    index: {
        type: String | Number,
        default: ''
    },
	groups_filedGroup_list: {
    	type: Array,
    	default: () => [],
    },
    global_filedGroup_list: {
    	type: Array,
    	default: () => [],
    },
},
components:{
    multilineText,
    singleText,
    orderRadio,
    orderCheckbox,
    editor,
    orderRange,
    orderNumber,
    orderDigit,
	groupOrderDuration
},
data() {
    return {
        groupInfo: {},
    	bargainReminderList: []
    };
},
mounted(){
    this.getFieldGroupDeatils()
	mittBus.on('validateFieldGroups', this.validateFieldGroups)
},
beforeDestroy() {
    // 销毁组件时移除监听（关键：避免内存泄漏）
    mittBus.off('validateFieldGroups')
},

methods: {
    async getFieldGroupDeatils(){
        const res = await getEquipmentFieldGroupList(this.info.fieldGroupId)
        this.groupInfo = res.data
        //查找字段组列表是否存在基本参数 fieIdType = 13 如果有则提替换formulaDetailList中fieIdId相同的值
		this.groupInfo.fieldGroupRelevanceList.map((item, index) => {
			// 初始化字段组相关信息----传入的info存有字段组信息的情况
			if(this.info.fieldGroupValues) {
				item.fieIdValue = this.info.fieldGroupValues[index].fieIdValue
			}
			if(item.fieIdRemark){
				item.fieIdRemark = item.fieIdRemark.replace(/{br}/g, "<br/>");
			}
			if(item.fieIdType == 13){
				this.groupInfo.formulaDetailList.map(items => {
					if(item.fieIdId == items.fieIdId){
						items.value = item.basicValue
					}
				})
			} 
			if(item.fieIdType == 1){
				item.isActive = false
			}
		})
		this.$nextTick(() => {
			if(this.global_filedGroup_list.length) {
		        this.global_filedGroup_list.forEach((item, index) => {
		        	switch(item.fieIdType) {
		        		case 1:
		        		    this.groupInfo.fieldGroupRelevanceList[index].optionId = item.valueId
		        			const selected_radio = item.options.filter( item_ => item_.optionId == item.valueId )
		        			const obj_radio = {
		        				value: selected_radio[0].unitPrice, 
		        				fieIdValue: selected_radio[0].optionName, 
		        				fieIdId: item.fieIdId, 
		        				optionId: [selected_radio[0].optionId], 
		        				options: item.options ,
		        			}
		        			this.updateChangeValue(obj_radio)
		        		break
		        		case 3:
		        		    const obj_text_1 = {
		        		    	type: 1,
		        		    	fieIdId: item.fieIdId,
		        		    	fieIdValue: item.fieIdValue,
		        		    }
		        			this.updateLineValue(obj_text_1)
		        		break
		        		case 4:
		        		    const obj_text_2 = {
		        		    	type: 1,
		        		    	fieIdId: item.fieIdId,
		        		    	fieIdValue: item.fieIdValue,
		        		    }
		        		    this.updateLineValue(obj_text_2)
		        		break
		        		case 5:
		        		    const obj_text_3 = {
		        		    	type: 1,
		        		    	fieIdId: item.fieIdId,
		        		    	fieIdValue: item.fieIdValue,
		        		    }
		        		    this.updateLineValue(obj_text_3)
		        		break
		        		case 6:
		        		    const obj_text_4 = {
		        				type: 6,
		        				fieIdValue: item.fieIdValue,
		        				fieIdId: item.fieIdId,
		        			}
		        			this.updateValue(obj_text_4)
		        		break
		        		case 7:
		        		    const obj_text_5 = {
		        				type: 7,
		        				fieIdValue: item.fieIdValue,
		        				fieIdId: item.fieIdId,
		        			}
		        			this.updateValue(obj_text_5)
		        		break
		        		case 9:
						    const range_min = {
                                type: 1,
                                fieIdId: item.fieIdId,
                                fieIdValue: item.fieIdValue,
                                fieldValueRange: item.fieldValueRange,
								value: Number(item.fieldValueRange - item.fieIdValue)
			                }
			                const range_max = {
                                type: 2,
                                fieIdId: item.fieIdId,
                                fieIdValue: item.fieIdValue,
                                fieldValueRange: item.fieldValueRange,
								value: Number(item.fieldValueRange - item.fieIdValue)
						    }
		        		    this.updateRangeValue(range_min)
		        		    this.updateRangeValue(range_max)
		        		break
		        		case 14:
		        		    item.duration = item.fieIdValue
		        		    this.updateTimeValue(item)
		        		break
		        	}
		        	this.$forceUpdate()
		        })
		    }
		    if(this.groups_filedGroup_list.length) {
		    	this.groups_filedGroup_list.forEach((item, index) => {
		    		switch(item.fieIdType) {
		    			case 1:
		    			    this.groupInfo.fieldGroupRelevanceList[index].optionId = item.valueId
		    				const selected_radio = item.options.filter( item_ => item_.optionId == item.valueId )
		    				const obj_radio = {
								index: index,
		    					value: selected_radio[0].unitPrice, 
		    					fieIdValue: selected_radio[0].optionName, 
		    					fieIdId: item.fieIdId, 
		    					optionId: [selected_radio[0].optionId], 
		    					options: item.options ,
		    				}
		    				this.updateChangeValue(obj_radio)
		    			break
		    			case 3:
		    			    const obj_text_1 = {
								index: index,
		    			    	type: 1,
		    			    	fieIdId: item.fieIdId,
		    			    	fieIdValue: item.fieIdValue,
		    			    }
		    				this.updateLineValue(obj_text_1)
		    			break
		    			case 4:
		    			    const obj_text_2 = {
								index: index,
		    			    	type: 1,
		    			    	fieIdId: item.fieIdId,
		    			    	fieIdValue: item.fieIdValue,
		    			    }
		    			    this.updateLineValue(obj_text_2)
		    			break
		    			case 5:
		    			    const obj_text_3 = {
								index: index,
		    			    	type: 1,
		    			    	fieIdId: item.fieIdId,
		    			    	fieIdValue: item.fieIdValue,
		    			    }
		    			    this.updateLineValue(obj_text_3)
		    			break
		    			case 6:
		    			    const obj_text_4 = {
								index: index,
		    					type: 6,
		    					fieIdValue: item.fieIdValue,
		    					fieIdId: item.fieIdId,
		    				}
		    				this.updateValue(obj_text_4)
		    			break
		    			case 7:
		    			    const obj_text_5 = {
								index: index,
		    					type: 7,
		    					fieIdValue: item.fieIdValue,
		    					fieIdId: item.fieIdId,
		    				}
		    				this.updateValue(obj_text_5)
		    			break
		    			case 9:
						    const range_min = {
								index: index,
                                type: 1,
                                fieIdId: item.fieIdId,
                                fieIdValue: item.fieIdValue,
                                fieldValueRange: item.fieldValueRange,
								value: Number(item.fieldValueRange - item.fieIdValue)
			                }
			                const range_max = {
								index: index,
                                type: 2,
                                fieIdId: item.fieIdId,
                                fieIdValue: item.fieIdValue,
                                fieldValueRange: item.fieldValueRange,
								value: Number(item.fieldValueRange - item.fieIdValue)
						    }
		    			    this.updateRangeValue(range_min)
		    			    this.updateRangeValue(range_max)
		    			break
		    			case 14:
		    			    item.duration = item.fieIdValue
		    			    this.updateTimeValue(item)
		    			break
		    		}
		    	})
		    }
		})
    },
	updateEditor(){
		//更新完成后重新计算值
		this.UpdateResult(val)
	},
    //更新范围值
	updateRangeValue(val){
		// 将对应组件的值更新到字段列表中
		this.groupInfo.fieldGroupRelevanceList.map(item => {
			if(item.fieIdId == val.fieIdId){
				// type 1 开始时间 2 结束时间
				if(val.type == 1){
					item.value = val.value
					item.fieIdValue = val.fieIdValue
				}
				if(val.type == 2){
					item.value = val.value
					item.fieldValueRange = val.fieldValueRange
				}
			}
		})
		//更新完成后重新计算值
		this.UpdateResult(val)
	},
    //更新单行文本
	updateLineValue(val){
		// 将对应组件的值更新到字段列表中
		this.groupInfo.fieldGroupRelevanceList.map(item => {
			if(item.fieIdId ==val.fieIdId){
				item.fieIdValue = val.fieIdValue
			}
		})
		//更新完成后重新计算值
		this.UpdateResult()
	},
    //查询是否有议价的选项
	getNegotiatedPriceOptions() {
	    // 先筛选出 fieIdType 为 1 或 2 的项目，且 valueId 存在
	    const filteredItems = this.groupInfo.fieldGroupRelevanceList.filter(item =>
	        (item.fieIdType === 1 || item.fieIdType === 2) && item.valueId
	    );
		this.bargainReminderList = []
	
	    // 然后处理这些筛选出的项目
	    filteredItems.forEach(item => {
	        // 将 valueId 分割成数组
	        let valueIds = item.valueId.split(',');
	        // 遍历 options，找出 isNegotiatedPrice 为 1 的选项
	        item.options.forEach(option => {
	            if (valueIds.includes(option.optionId.toString()) && option.isNegotiatedPrice === 1) {
	                // 如果找到议价选项，添加其 bargainReminder 到列表
	                this.bargainReminderList.push(option.bargainReminder);
	            }
	        });
	    });
	},
	//更新单选
	updateChangeValue(val){
		// 将对应组件的值更新到字段列表中
		this.groupInfo.fieldGroupRelevanceList.map(item => {
			if(item.fieIdId == val.fieIdId){
				item.value = val.value
				item.valueId = val.optionId
				item.fieIdValue = val.fieIdValue
				item.valueId = item.valueId.join(',')
			}
		})
		this.getNegotiatedPriceOptions()
		//更新完成后重新计算值
		this.UpdateResult(val)
	},
	//更新时间
	updateTimeValue(val){
		// 将时间更新到字段上
		let updateObj = {}
		this.groupInfo.fieldGroupRelevanceList.map(item => {
			if(item.fieIdId == val.fieIdId){
				item.appointmentStartDate = val.appointmentStartDate
				item.appointmentEndDate = val.appointmentEndDate
				item.duration = val.duration
				//如果是日历预约则计算出时长
				if(item.isEnableCalendar == 1){
					if(item.appointmentStartDate && item.appointmentEndDate){
						item.value = this.$orderUtils.CalculateDuration(val.appointmentStartDate,val.appointmentEndDate)
					}else{
						item.value = 0
					}
				}else{
					item.value = item.duration
					item.fieIdValue = item.duration
				}
				updateObj = item
			}
		})
		this.$forceUpdate()
		this.UpdateResult(updateObj)
	},
    //更新数字相关的值
	updateValue(val){
		// 将对应组件的值更新到字段列表中
		this.groupInfo.fieldGroupRelevanceList.map(item => {
			if(item.fieIdId ==val.fieIdId){
				item.value = val.fieIdValue
				item.fieIdValue = val.fieIdValue
				// //单选可能会有议价的情况
				// if(item.isNegotiatedPrice == 1){
				// 	this.isNegotiatedPrice = 1
				// }
			}
		})
		//更新完成后重新计算值
		this.UpdateResult(val)
	},
    UpdateResult(val){
		//将字段列表的值 赋予到计算数组中
		if(val){
			this.groupInfo.formulaDetailList.map(item => {
				if(item.flag == false){
					if(item.fieIdId == val.fieIdId){
						item.isCalculatePrice = val.isCalculatePrice
						// item.value = Number(val.fieIdValue)
						//单选多选范围使用value 整数 浮点数使用fieIdValue
						if(item.fieIdType == 6 || item.fieIdType == 7){
							item.value = Number(val.fieIdValue)
						}
						if(item.fieIdType == 1 || item.fieIdType == 2 || item.fieIdType == 9){
							if(item.fieIdType == 1){
							}
							item.value = Number(val.value)
						}
						if(item.fieIdType == 14){
							item.value = Number(val.value)
							item.elementPrice = Number(val.elementPrice)
						}
					}
				}
			})
		}
		//拼接this.groupInfo.formulaDetailList.map（算式
		let NumSum = ``
		this.groupInfo.formulaDetailList.map(item => {
			if(item.flag){
				NumSum += item.fieIdName
			}else{
				//如果是日期则需要查询他是否本身也参与了计算
				if(item.fieIdType == 14){
					if(item.isCalculatePrice == 0){
						if(item.value && item.value !== undefined && item.value != null && item.value != NaN){
							NumSum += item.value
						}else{
							NumSum += 0
						}
					}else{
						if(item.value && item.value !== undefined && item.value != null && item.value != NaN && item.elementPrice){
							NumSum = `${item.value}*${item.elementPrice}+${NumSum}${item.value}`
						}else{
							NumSum += 0
						}
					}
				}else{
					if(item.value && item.value !== undefined && item.value != null && item.value != NaN){
						NumSum += item.value
					}else{
						NumSum += 0
					}
				}
			}
		})
		const math = require('mathjs')
        const absRegex = /\|([^|]+)\|/g // 使用正则表达式找到所有绝对值部分
        let match;
        let processedExpression = JSON.parse(JSON.stringify(NumSum))
		// 遍历所有匹配的绝对值表达式
		while ((match = absRegex.exec(NumSum)) !== null) {
            const absExpression = match[1]; // 绝对值内部的表达式
            // 计算绝对值内部表达式
            const innerResult = math.evaluate(absExpression)
            // 计算绝对值
            const absResult = Math.abs(innerResult)
            // 替换原表达式中的绝对值部分
            processedExpression = processedExpression.replace(`|${absExpression}|`, absResult.toString())
        }
		// 计算最终结果
        let result = math.evaluate(processedExpression);

		// const math = require('mathjs')
		// let result = math.evaluate(NumSum);
		
		if(result === NaN || result === Infinity || result === undefined){
			result = 0
		}
		//reservePointMethod 1 保留两位 2向上取整
		if(this.groupInfo.reservePointMethod == 1){
			result = math.format(result, { notation: 'fixed', precision: 2 });
		}else{
			result = math.ceil(result);
		}
		let obj = {
			index: this.index,
			totalPrice: result,
			fieIdId: this.info.fieIdId,
			fieldGroupValues: this.groupInfo.fieldGroupRelevanceList,
			fieldGroupId: this.groupInfo.fieldGroupId,
			bargainReminderList: this.bargainReminderList
		}
		this.$emit('updateGroupValue',obj)
	},
	validateFieldGroups(fieldGroups_result) {
		if(fieldGroups_result.fieldGroupId != this.groupInfo.fieldGroupId) return
		fieldGroups_result.fieldGroupValues.forEach(item => {
			if([2, 10, 11, 12, 13].includes(item.fieIdType)) return
			const index = this.groupInfo.fieldGroupRelevanceList.findIndex(i => i.fieIdId == item.fieIdId)
			if(item.fieIdType == 6) {
                this.groupInfo.fieldGroupRelevanceList[index].validate = item.fieIdValue == undefined || item.fieIdValue == null
			} else if(item.fieIdType == 9) {
                this.groupInfo.fieldGroupRelevanceList[index].validate = item.fieIdValue == undefined || item.fieIdValue == null || item.fieldValueRange == undefined || item.fieldValueRange == null || (item.fieIdValue == item.fieldValueRange)
            } else {
                this.groupInfo.fieldGroupRelevanceList[index].validate = !item.fieIdValue
            }
		})
		this.$forceUpdate()
	},
},
};
</script>

<style lang='scss' scoped>
.validate-form {
  width: 100%;
  padding: 15px;
  border: 1px solid #FF4A2B;
}
</style>